import { render, staticRenderFns } from "./rewardTradeDetails.vue?vue&type=template&id=b3284016"
import script from "./rewardTradeDetails.vue?vue&type=script&lang=js"
export * from "./rewardTradeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports